import { Button } from 'edenred-ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  font-size: 14px;
  min-width: 200px;
`;
